export default __webpack_public_path__ + "static/media/chevron.2e7db1d9.svg";